module.exports = __webpack_public_path__ + "img/img-empresas-anter_empresa-1.c133510e.svg";